import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff78e62a&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ff78e62a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff78e62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff78e62a')) {
      api.createRecord('ff78e62a', component.options)
    } else {
      api.reload('ff78e62a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff78e62a&scoped=true&lang=pug", function () {
      api.rerender('ff78e62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/header/index.vue"
export default component.exports